import { stringify } from "query-string"
import { apiInstance } from "./api"

const endpoint = "/coupon"

export const getPublicCoupons = async queries => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.get(`${endpoint}/public?${query}`)

  return response.data
}

export const getCombos = async (queries) => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.get(`${endpoint}/public/comboset/all?${query}`)

  return response.data
}

export const getAutoApplyCoupons = async (queries) => {
  const query =
    stringify(queries,
      {
        skipEmptyString: true,
        skipNull: true
      }
    )

  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/auto?${query}`)

  return response.data
}